//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/DisplayableObject.js";
let d=[[],[[["components"],"AddObjectsToReferenceSet",{},1,0],[["components"],"RemoveObjectsFromReferenceSet",{},1,0],[["numMembers"],"AskMembersInReferenceSet",{R_:{members:"NXObject[]"}},0,0],[["numMembers"],"AskAllDirectMembers",{R_:{members:"NXObject[]"}},0,0],[["newValue","addExistingComponents"],"SetAddComponentsAutomatically",{},2,0],[[],"GetAddComponentsAutomatically",{R_:{currentValue:''}},0,0]],[]];
SPLM.ReferenceSet = class extends SPLM.DisplayableObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.ReferenceSet";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;